// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"
// syntax highlighting with prismjs
import "prismjs/themes/prism-tomorrow.css"
// trigger an immediate page refresh when an update is found
export const onServiceWorkerUpdateReady = () => window.location.reload();
